import React from "react";
import { ethers } from "ethers";
import Gauge from "./charts/Gauge";
import Button from "./common/Button";
import { bnToNumber, fmtUsdt } from "../utils/format";

// Ceilings at/near uint256 max mean an unlimited (VIP) tier.
const UNLIMITED_THRESHOLD = ethers.constants.MaxUint256.div(2);

// status: "active" | "upgrade" | "locked"
// detail: getUserPackageDetails tuple (only meaningful when active)
export default function PackageCard({ pkg, status, detail, onUpgrade, onRetopup }) {
  if (status === "active" && detail) {
    const unlimited = detail.ceilingLimit.gte(UNLIMITED_THRESHOLD);
    const earned = bnToNumber(detail.totalEarned);
    const ceiling = bnToNumber(detail.ceilingLimit);
    const pct = unlimited ? 0 : ceiling > 0 ? earned / ceiling : 0;

    return (
      <div className="pkg-card active card-hover fade-up">
        <div className="pkg-top">
          <div>
            <div className="pkg-name">{pkg.label}</div>
            <div className="pkg-id muted">#{pkg.id} · ${pkg.price.toLocaleString()}</div>
          </div>
          {unlimited
            ? <span className="badge" style={{ color: "var(--gold)", borderColor: "rgba(255,207,92,0.4)" }}>★ VIP</span>
            : <span className="badge ok"><span className="dot-live" />Active</span>}
        </div>

        <Gauge
          pct={pct}
          centerTop={unlimited ? "∞" : `${Math.round(pct * 100)}%`}
          centerBottom={unlimited ? "unlimited" : "of 2X ceiling"}
        />

        <div className="pkg-stats">
          <div className="pkg-stat">
            <span className="muted">Ceiling</span>
            <strong>{unlimited ? "∞" : fmtUsdt(detail.ceilingLimit)}</strong>
          </div>
          <div className="pkg-stat">
            <span className="muted">Earned</span>
            <strong style={{ color: "var(--gold)" }}>{fmtUsdt(detail.totalEarned)}</strong>
          </div>
          <div className="pkg-stat">
            <span className="muted">Available</span>
            <strong style={{ color: "var(--success)" }}>{unlimited ? "∞" : fmtUsdt(detail.remainingCeiling)}</strong>
          </div>
        </div>

        <Button className="btn-block btn-3d mt-3" onClick={() => onRetopup(pkg)}>
          ⟳ Re-topup (${pkg.price.toLocaleString()})
        </Button>
      </div>
    );
  }

  if (status === "upgrade") {
    return (
      <div className="pkg-card upgrade card-hover fade-up">
        <div className="pkg-top">
          <div>
            <div className="pkg-name">{pkg.label}</div>
            <div className="pkg-id muted">#{pkg.id}</div>
          </div>
        </div>
        <div className="pkg-price grad-text">${pkg.price.toLocaleString()}</div>
        <div className="pkg-sub muted">USDT</div>
        <Button className="btn-block mt-3" onClick={() => onUpgrade(pkg)}>Upgrade</Button>
      </div>
    );
  }

  return (
    <div className="pkg-card locked fade-up">
      <div className="pkg-top">
        <div>
          <div className="pkg-name">{pkg.label}</div>
          <div className="pkg-id muted">#{pkg.id}</div>
        </div>
        <span className="badge off">🔒</span>
      </div>
      <div className="pkg-price muted">${pkg.price.toLocaleString()}</div>
      <div className="pkg-sub muted">Activate previous first</div>
    </div>
  );
}
